import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

class CounterComponent {
    constructor() {
        this.count = 0;
        /** Emitted Count Value. */
        this.countEmitter = new EventEmitter();
    }
    ngOnInit() {
        if (!this.count) {
            this.count = 0;
        }
    }
    /** will do increment in count. */
    increment() {
        this.count++;
        this.countEmitter.emit(this.count);
    }
    /** will do decrement in count. */
    decrement() {
        if (this.count > 0) {
            this.count--;
            this.countEmitter.emit(this.count);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CounterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CounterComponent, selector: "fgbcl-counter", inputs: { count: "count" }, outputs: { countEmitter: "countEmitter" }, ngImport: i0, template: "<div class=\"counter-container\">\r\n  <span (click)=\"increment()\" class=\"material-icons-outlined\"> keyboard_arrow_up </span>\r\n  <div class=\"counter-display\">{{ count }}</div>\r\n  <span (click)=\"decrement()\" class=\"material-icons-outlined\"> keyboard_arrow_down </span>\r\n</div>\r\n", styles: [".counter-container{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:10px}.material-icons-outlined{font-size:36px;cursor:pointer;-webkit-user-select:none;user-select:none;outline:none}.counter-display{width:50px;height:50px;display:flex;align-items:center;justify-content:center;font-size:26px;font-weight:700;color:#000;border:1px solid #dedddd;border-radius:16px}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CounterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fgbcl-counter', template: "<div class=\"counter-container\">\r\n  <span (click)=\"increment()\" class=\"material-icons-outlined\"> keyboard_arrow_up </span>\r\n  <div class=\"counter-display\">{{ count }}</div>\r\n  <span (click)=\"decrement()\" class=\"material-icons-outlined\"> keyboard_arrow_down </span>\r\n</div>\r\n", styles: [".counter-container{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:10px}.material-icons-outlined{font-size:36px;cursor:pointer;-webkit-user-select:none;user-select:none;outline:none}.counter-display{width:50px;height:50px;display:flex;align-items:center;justify-content:center;font-size:26px;font-weight:700;color:#000;border:1px solid #dedddd;border-radius:16px}\n"] }]
        }], propDecorators: { count: [{
                type: Input
            }], countEmitter: [{
                type: Output
            }] } });

class CounterModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CounterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CounterModule, declarations: [CounterComponent], imports: [CommonModule], exports: [CounterComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CounterModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CounterModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CounterComponent],
                    imports: [CommonModule],
                    exports: [CounterComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { CounterComponent, CounterModule };
